import Signup from "../components/signup";

const SignupPage = () => {
  return <Signup />;
};

export default SignupPage;
